import { render, staticRenderFns } from "./paymentPool.vue?vue&type=template&id=2c0131c0&scoped=true&"
import script from "./paymentPool.vue?vue&type=script&lang=js&"
export * from "./paymentPool.vue?vue&type=script&lang=js&"
import style0 from "./paymentPool.vue?vue&type=style&index=0&id=2c0131c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0131c0",
  null
  
)

export default component.exports